import { css } from "lit";

export const stylesBase = css`
  :host {
    display: inline-flex;
  }
`;
